import { DataType } from '../../redux/data/dataTypes';
import api from '../axios/axiosInstance';

const getData = async (storeId?: string, customerId?: string): Promise<DataType> => {
  const response = await api.get(`/users/data`, {
    params: {
      storeId,
      customerId,
    },
  });

  return response.data;
};

const geCurrency = async (): Promise<string> => {
  const response = await api.get(`/users/currency`);
  return response.data;
};
const gePin = async (): Promise<string> => {
  const response = await api.get(`/users/pin`);
  return response.data;
};
export default getData;
export { geCurrency, gePin };
